<template>
	<button @click="toggle()" class="md:hidden p-4 w-full flex">
		<h2 class="font-bold">Minha escolha</h2>
		<img :src="urlAssets + '/img/checkout/arrow-dow.svg'" class="ml-auto" />
	</button>

	<div v-if="product" class="md:block" :class="opened ? 'block' : 'hidden'">
		<ProductSubscriptionReview
			v-if="product?.product_type === OrderCheckoutType.SUBSCRIPTION"
			layout="compact"
			:has-action="false"
		/>
		<ProductPostpaidReview
			v-else-if="product?.product_type === OrderCheckoutType.POSTPAID"
			layout="compact"
			:has-action="false"
		/>
		<ProductPrepaidReview
			v-else
			layout="compact"
			:has-action="false"
		/>		
	</div>
</template>

<script lang="ts" setup>
import ProductPostpaidReview from "~/components/checkout/postpaid/product-review.vue";
import ProductPrepaidReview from "~/components/checkout/prepaid/product-review.vue";
import ProductSubscriptionReview from "~/components/checkout/subscription/product-review.vue";
import { useCheckoutStore } from "~/store/checkout";
import { storeToRefs } from "pinia";
import { OrderCheckoutType } from "~~/enums/orderCheckoutType";
const runtimeConfig = useRuntimeConfig();
const urlAssets = runtimeConfig.assetsUrl;
const checkout = useCheckoutStore();
const { product } = storeToRefs(checkout);
const opened = ref(false);
const toggle = () => (opened.value = !opened.value);
</script>

<style scoped></style>
